import styles from './KeypadButton.module.scss'

const KeypadButton = ({ title, subtitle, disabled, onClick }) => {
  return <button onClick={onClick} className={styles.button} disabled={disabled}>
    {title}
    {subtitle !== undefined && <span className={styles.subtitle}>{subtitle}</span>}
  </button>
}

export default KeypadButton